<template>
  <div class="col-xs-6 col-lg-12 listing-card">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ListingCard'
}
</script>

<style lang='scss' scoped>
.listing-card {
  border-bottom: 1px solid $grey-light;
  padding-top: 10px;
  padding-bottom: 10px;

  @include media-breakpoint-down(md) {
    border-bottom: none;
    padding-top: 0;
  }
}
</style>
